import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row} from "antd";
import { GUTTER_MD, MODAL_WIDTH_LG, SPAN_FULL, SPAN_ONE_THIRD, SPAN_TWO_THIRDS} from "../../styles/constants";
import {compose} from "redux";
import {translate} from "react-i18next";
import CustomEmpty from "../custom-empty";
import Selector from "../selector";
import { getHclReferenceValuesFromAnnotation, setHclReferenceAnnotation } from "../../utils/annotations";
import ArtefactList from "../../components/artefact-list";
// import _ from "lodash";
import EnhancedModal from "../enhanced-modal";
import Call from "../../hocs/call";
import _ from "lodash";
import { getArtefactTripletFromUrn, getStringFromArtefactTriplet } from "../../utils/sdmxJson";

// const formItemLayoutHcl = {
//   labelCol: {span: SPAN_ONE_THIRD},
//   wrapperCol: {span: SPAN_TWO_THIRDS}
// };

// const formItemLayoutHier = {
//   labelCol: {span: SPAN_HALF},
//   wrapperCol: {span: SPAN_HALF}
// };

// const getformItemLayout = (hclTriplet) => {
//   return hclTriplet ? formItemLayoutHcl : formItemLayoutHier 
// }

const HCLReferencesForm = ({ 
  t,
  disabled,
  dsdDimensions,
  dsdAttributes,
  layoutAnnotations,
  annotationsConfig,
  hierarchicalCodelists,
  fetchHierarchicalCodelists,
  onChange
}) => {

  const [codedComponents, setCodedComponents] = useState(null);
  const [isSelectorVisible, setSelectorVisible] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState(null);

  useEffect(() => {
    const hclReferenceValues = getHclReferenceValuesFromAnnotation(layoutAnnotations, annotationsConfig) || {};
    const componentsWithRepresentation = ((dsdDimensions || []).filter(dim => dim.representation) || [])
    .concat(((dsdAttributes || []).filter(attr => attr.representation) || []));
    const formComponents = [];
    componentsWithRepresentation
      .forEach(comp => {
        formComponents.push({
          id: comp.id,
          hclTriplet: hclReferenceValues[comp.id] ? hclReferenceValues[comp.id].hclTriplet : null,
          hierId: hclReferenceValues[comp.id] ? hclReferenceValues[comp.id].hierId : null
        })
      });
    setCodedComponents(formComponents);
  }, [layoutAnnotations, annotationsConfig, dsdDimensions, dsdAttributes]);

  const onComponentSelect = (comp) => {
    setSelectedComponent(comp);
    setSelectorVisible(true);    
  }

  const onAnnotationsChange = (components) => {

    if (onChange) {

      const componentsWithHclRef = [];
      (components.filter(comp => comp.hclTriplet) || [])
        .forEach(comp => componentsWithHclRef.push(
            {
              id: comp.id,
              hclTriplet: comp.hclTriplet,
              hierId: comp.hierId
            }
          )
        );

        const newLayoutAnnotations = setHclReferenceAnnotation(layoutAnnotations, annotationsConfig, componentsWithHclRef);
        onChange({layoutAnnotations:newLayoutAnnotations});
    }
    
  }

  const onSetComponentHcl = (compId, urn) => {
    const components = _.cloneDeep(codedComponents);
    const component = components.find(comp => comp.id === compId);
    component.hclTriplet = urn 
      ? getArtefactTripletFromUrn(urn) 
      : null;
    component.hierId = null;
     
    if (isSelectorVisible) {
      setSelectorVisible(false);
    };

    onAnnotationsChange(components);
    
  }

  const onSetComponentHierId = (compId, hierId) => {
    const components = _.cloneDeep(codedComponents);
    const component = components.find(comp => comp.id === compId);
    component.hierId = hierId;

    onAnnotationsChange(components);
  }
 // className="advanced-form"

  return (
    <Call
      cb={fetchHierarchicalCodelists}
      disabled={hierarchicalCodelists !== null}
    >
      <Form className="advanced-form">
        {(codedComponents && codedComponents.length > 0)
          ? (
              codedComponents.map((comp, key) =>
                <Row gutter={GUTTER_MD} key={key}>
                  <Col span={comp.hclTriplet ? SPAN_TWO_THIRDS : SPAN_FULL}>
                    <Form.Item
                      key={`Hcl_${key}`}
                      label={comp.id}
                      //{...getformItemLayout(comp.hclTriplet)}
                    > 
                      <Selector
                        disabled={disabled}
                        onSelect={() => onComponentSelect(comp)}
                        onReset={() => onSetComponentHcl(comp.id, null)}
                        value={comp.hclTriplet ? getStringFromArtefactTriplet(comp.hclTriplet) : null}                   
                      />
                    </Form.Item>
                  </Col>                 
                  { comp.hclTriplet 
                    ? <Col span={SPAN_ONE_THIRD}>                     
                      <Form.Item
                          key={`HierId_${key}`}
                          label={t("data.annotation.hcl.hierId.label")}
                          // {...formItemLayoutHier}
                        > 
                          <Input
                            value={comp.hierId ? comp.hierId : null}  
                            onChange={({target}) => onSetComponentHierId(comp.id,target.value)}
                            style={{textTransform: "uppercase"}}                 
                          />
                        </Form.Item>
                    </Col>
                    : null 
                  }
                </Row>
                
              )              
            )
          : <CustomEmpty/>
        }
      </Form>

      <EnhancedModal
        visible={isSelectorVisible && hierarchicalCodelists !== null}
        width={MODAL_WIDTH_LG}
        title={t('reduxComponents.dsdDetail.hierarchicalCodelistsSelector.title')}
        onCancel={() => setSelectorVisible(false)}
        footer={
          <Button 
            onClick={() => setSelectorVisible(false)}
          >
            {t('commons.buttons.close.title')}
          </Button>
        }
        withDataLanguageSelector
      >
        <ArtefactList
          artefacts={hierarchicalCodelists}
          onRowClick={({urn}) => onSetComponentHcl(selectedComponent.id, urn)}
        />
      </EnhancedModal>

    </Call>
  )

}

export default compose(
    translate(),
  )(HCLReferencesForm);